exports.components = {
  "component---src-pages-hiabram-js": () => import("./../../../src/pages/hiabram.js" /* webpackChunkName: "component---src-pages-hiabram-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

